<template>
    <div
        class="navbar_row_item"
        v-bind:class="[fluid ? 'navbar_row_item-fluid' : '', right ? 'navbar_row_item-right' : '']"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        fluid: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
    });
</script>
